import { theme } from "@Definitions/Styled";
import { Box, Grid, styled, Typography } from "@mui/material";

export const StyledBlock = styled(Box)(
  ({ theme }) => `
  display:flex;
  align-items:center;
   }
  `
);
export const StyledTitle = styled(Typography)(
  ({ theme }) => `
  font-size:1.3rem;
  font-weight:bold;
  padding:1rem;
}
  `
);
export const StyledGridContainer = styled(Grid)(`
  justify-content: center;
  margin-top:1rem;
  ${theme.breakpoints.down("sm")}{
    margin-top:5rem;
  }
`);

export const StyledContent = styled(Typography)(
  ({ theme }) => `
  font-size:1.1rem!important;
  padding: 0.3rem 1rem!important;
}
  `
);

export const StyledPreFooterLink = styled(Typography)`
  cursor:pointer;
  color: ${(props: any) => props.theme.palette.primary.main};
}
`;
